import { Component, inject, OnInit } from '@angular/core';
import { AuthService } from '@app/auth/auth.service';
import { GtmService, GtmEventType } from '@app/utils/gtm/gtm.service';

@Component({
  selector: 'app-onboarding',
  templateUrl: './onboarding.component.html',
})
export class OnboardingComponent implements OnInit {
  protected authService = inject(AuthService);
  private gtmService = inject(GtmService);

  ngOnInit(): void {
    this.gtmService.trackEvent(GtmEventType.ONBOARDING_START);
  }

  logOut() {
    this.gtmService.trackEvent(GtmEventType.ONBOARDING_ABANDONED);
    this.authService.logoutUser();
  }
}
